import { render, staticRenderFns } from "./boatTourInfo.vue?vue&type=template&id=2d090526&"
import script from "./boatTourInfo.vue?vue&type=script&lang=js&"
export * from "./boatTourInfo.vue?vue&type=script&lang=js&"
import style0 from "./boatTourInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports